<div class="access-denied" [class.access-denied--fill]="fill()">
  <div class="access-denied__icon"><app-icon [name]="displayIcon()" [size]="26" /></div>
  <h2 class="access-denied__title">{{ displayTitle() }}</h2>
  <p class="access-denied__message">{{ displayMessage() }}</p>
  @if (homeLink(); as link) {
    <a class="access-denied__action" [routerLink]="link">{{ homeLabel() }}</a>
  }
</div>
